module.exports = __webpack_public_path__ + "img/calendar.0ebc7d15.png";